import { useSnackbar } from "notistack";
import { useDownloadFile } from "../../components/downloadFileButton/useDownloadFile";
import { getCallRecordingFile } from "./callRecordingsApi";

export const useDownloadCallRecording = (recId: string, contactName: string, date: string) => {
  const { enqueueSnackbar } = useSnackbar();
  const { download, isLoading } = useDownloadFile({
    apiDefinition: () => getCallRecordingFile(recId),
    onError: () => {
      enqueueSnackbar("Nie udało się pobrać nagrania rozmowy", { variant: "error" });
    },
    filename: () => `rozmowa_${contactName}_${date}.mp3`,
  });

  return { download: () => download(), isLoading };
};
